import React from 'react';
import LandingPage from './components/LandingPage';
import './App.css';

function App() {
  return (
    <div className="min-h-screen">
      <LandingPage />
    </div>
  );
}

export default App;